import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Icon3dot, IconLoading, IconArrowRight } from '../../../../assets/icon';
import ButtonTypes from '../../../../constants/buttonTypes';
import ButtonDropdownMenuItem from '../../../../components/ButtonDropdownMenuItem/ButtonDropdownMenuItem';
import CustomDropdownMenu from '../../../../components/CustomDropdownMenu/CustomDropdownMenu';
import coOrderStatus from '../../../../constants/coOrderStatus';
import PermissionsGate from '../../../../components/PermissionsGate/PermissionsGate';
import { permissions } from '../../../../common/permissionGroup';

const actionButtonClassName = 'px-[10px] py-[5px] w-[26px] h-[26px] min-w-[26px] min-h-[26px]';
const actionContainerClassName = 'min-w-[250px] z-[3000]';
const actionMenuBodyClassName = 'relative';
const actionMenuOverlayClassName = [
  'absolute inset-0 bg-white/60 dark:bg-[#0d1b2a]/60 z-[5]',
  'flex items-center justify-center'
].join(' ');
const actionMenuSectionClassName = 'flex flex-col gap-[2px]';
const actionSubmenuClassName = 'relative';
const actionSubmenuTriggerClassName = 'block';
const actionSubmenuArrowClassName = 'w-[12px] h-[12px]';
const actionSubmenuListClassName = [
  'static mt-[4px] ml-[16px] min-w-0 rounded-[6px]',
  'sm:absolute sm:top-0 sm:left-full sm:mt-0 sm:ml-[8px] sm:min-w-[220px]',
  'bg-white dark:bg-[#1b263b] shadow-[0_6px_18px_rgba(0,0,0,0.12)]',
  'p-[8px] z-[3]'
].join(' ');
const actionSubmenuClosedClassName = 'hidden sm:block opacity-0 translate-x-[-4px] pointer-events-none';
const actionSubmenuOpenClassName = 'opacity-100 translate-x-0 pointer-events-auto';

const CoOrdersActions = ({
  side, onEdit, onLateCorrection, onCancel,
  onArchived, onLostInProcess, onCheckAvailability, onDoneOrder,
  onRelease, onPickup, onPrintLabel,
  status, onPrintWrLabel, onMissingParts, onPrintProductLabel, onCreateShipLabel, isOverstock,
  onInvoiceView, onOrderIssue, toOverstock, isLoading
}) => {
  const [visible, toggleVisible] = useState(false);
  const [printOpen, setPrintOpen] = useState(false);
  const [dangerOpen, setDangerOpen] = useState(false);

  const handleMenuToggle = (nextVisible) => {
    toggleVisible(nextVisible);
    if (!nextVisible) {
      setPrintOpen(false);
      setDangerOpen(false);
    }
  };

  const handlePrintAction = (action) => {
    if (action) {
      action();
    }
    setPrintOpen(false);
    toggleVisible(false);
  };

  const handleDangerAction = (action) => {
    if (action) {
      action();
    }
    setDangerOpen(false);
    toggleVisible(false);
  };

  return (
    <CustomDropdownMenu
      Icon={Icon3dot}
      btnType={ButtonTypes.LIGHT}
      side={side}
      drop="right"
      btnStyle={actionButtonClassName}
      containerStyle={actionContainerClassName}
      mainContainerStyle={actionMenuBodyClassName}
      show={visible}
      onToggle={handleMenuToggle}
      usePortal
    >
      {isLoading && (
        <div className={actionMenuOverlayClassName}>
          <IconLoading className="spin" />
        </div>
      )}
      <div className={actionMenuSectionClassName}>
        <ButtonDropdownMenuItem
          text="Edit"
          onClick={() => {
            onEdit();
            toggleVisible(false);
          }}
        />
        {[coOrderStatus.PART_BOX, coOrderStatus.PACK_BOX, coOrderStatus.PACKED].includes(status)
          && onLateCorrection && (
          <PermissionsGate can={permissions.ADMIN_ADMIN}>
            <ButtonDropdownMenuItem
              text="Late correction"
              onClick={() => {
                onLateCorrection();
                toggleVisible(false);
              }}
            />
          </PermissionsGate>
        )}
        <div className={actionSubmenuClassName}>
          <div className={actionSubmenuTriggerClassName}>
            <ButtonDropdownMenuItem
              text="Label"
              onClick={() => {
                setPrintOpen((current) => !current);
                setDangerOpen(false);
              }}
              rightIcon={<IconArrowRight className={actionSubmenuArrowClassName} />}
            />
          </div>
          <div
            className={`${actionSubmenuListClassName} ${
              printOpen ? actionSubmenuOpenClassName : actionSubmenuClosedClassName
            }`}
          >
            {onCreateShipLabel && (
              <ButtonDropdownMenuItem
                text="Create ship label"
                onClick={() => handlePrintAction(onCreateShipLabel)}
              />
            )}
            <ButtonDropdownMenuItem
              text="Print WR Label"
              onClick={() => handlePrintAction(onPrintWrLabel)}
            />
            <ButtonDropdownMenuItem
              text="Print Ship label"
              onClick={() => handlePrintAction(onPrintLabel)}
            />
            <ButtonDropdownMenuItem
              text="Print product label"
              onClick={() => handlePrintAction(onPrintProductLabel)}
            />
          </div>
        </div>
        {!isOverstock && (
          <ButtonDropdownMenuItem
            text="Missing Parts"
            onClick={() => {
              onMissingParts();
              toggleVisible(false);
            }}
          />
        )}

        {(status === coOrderStatus.NEW
            || status === coOrderStatus.OUT_OF_STOCK
            || status === coOrderStatus.OUT_OF_RESERVE)
          && (
            <ButtonDropdownMenuItem
              text="Check Availability"
              onClick={onCheckAvailability}
            />
          )}
        {(status === coOrderStatus.OUT_OF_RESERVE
          || status === coOrderStatus.OUT_OF_STOCK
          || status === coOrderStatus.READY_ASB) && (
          <ButtonDropdownMenuItem
            text="Done order"
            onClick={onDoneOrder}
          />
        )}
        {status === coOrderStatus.READY_ASB
          && (
            <ButtonDropdownMenuItem
              text="Release"
              onClick={onRelease}
            />
          )}
        <ButtonDropdownMenuItem
          text="Pickup"
          onClick={onPickup}
        />
        {onInvoiceView && (
          <ButtonDropdownMenuItem
            text="View Invoice"
            onClick={onInvoiceView}
          />
        )}
        {(status === coOrderStatus.PACK_BOX
          || status === coOrderStatus.PART_BOX
          || status === coOrderStatus.PICKED
            || status === coOrderStatus.PACKED)
          && toOverstock && (
          <ButtonDropdownMenuItem
            text="To overstock"
            onClick={toOverstock}
          />
        )}
        <div className={actionSubmenuClassName}>
          <div className={actionSubmenuTriggerClassName}>
            <ButtonDropdownMenuItem
              danger
              text="Danger zone"
              onClick={() => {
                setDangerOpen((current) => !current);
                setPrintOpen(false);
              }}
              rightIcon={<IconArrowRight className={actionSubmenuArrowClassName} />}
            />
          </div>
          <div
            className={`${actionSubmenuListClassName} ${
              dangerOpen ? actionSubmenuOpenClassName : actionSubmenuClosedClassName
            }`}
          >
            {status !== coOrderStatus.PACKED
              && status !== coOrderStatus.PACK_BOX
              && status !== coOrderStatus.PICKED
              && status !== coOrderStatus.SHIPPED && (
              <ButtonDropdownMenuItem
                danger
                text="Cancel"
                onClick={() => handleDangerAction(onCancel)}
              />
            )}
            <ButtonDropdownMenuItem
              danger
              text="Order issue"
              onClick={() => handleDangerAction(onOrderIssue)}
            />
            {[coOrderStatus.PART_BOX, coOrderStatus.PACK_BOX, coOrderStatus.PACKED].includes(status)
              && onLostInProcess && (
              <ButtonDropdownMenuItem
                danger
                text="Lost in process"
                onClick={() => handleDangerAction(onLostInProcess)}
              />
            )}
            <ButtonDropdownMenuItem
              danger
              text="Archived"
              onClick={() => handleDangerAction(onArchived)}
            />
          </div>
        </div>
      </div>
    </CustomDropdownMenu>
  );
};

CoOrdersActions.propTypes = {
  side: PropTypes.string,
  status: PropTypes.string,
  onEdit: PropTypes.func,
  onLateCorrection: PropTypes.func,
  onCancel: PropTypes.func,
  onArchived: PropTypes.func,
  onLostInProcess: PropTypes.func,
  onCheckAvailability: PropTypes.func,
  onDoneOrder: PropTypes.func,
  onRelease: PropTypes.func,
  onPickup: PropTypes.func,
  onPrintLabel: PropTypes.func,
  onPrintWrLabel: PropTypes.func,
  onMissingParts: PropTypes.func,
  onPrintProductLabel: PropTypes.func,
  onCreateShipLabel: PropTypes.func,
  onInvoiceView: PropTypes.func,
  onOrderIssue: PropTypes.func,
  toOverstock: PropTypes.func,
  isOverstock: PropTypes.bool,
  isLoading: PropTypes.bool,
};

CoOrdersActions.defaultProps = {
  side: 'top',
  status: '',
  onEdit: undefined,
  onLateCorrection: undefined,
  onCancel: undefined,
  onArchived: undefined,
  onLostInProcess: undefined,
  onCheckAvailability: undefined,
  onDoneOrder: undefined,
  onRelease: undefined,
  onPickup: undefined,
  onPrintLabel: undefined,
  onPrintWrLabel: undefined,
  onMissingParts: undefined,
  onPrintProductLabel: undefined,
  onCreateShipLabel: undefined,
  onInvoiceView: undefined,
  onOrderIssue: undefined,
  toOverstock: undefined,
  isOverstock: false,
  isLoading: false,
};

export default CoOrdersActions;
